import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import './JoinUs.css';

const JoinUs = () => {
  const navigate = useNavigate();

  // Always open from top
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="ju-page">
      {/* Hero */}
      <section className="ju-hero">
        <div className="container">
          <div className="ju-hero-content">
            <span className="ju-eyebrow">Membership Application</span>
            <h1 className="ju-hero-title">Become a part of the Elite Freight Forwarders Network!</h1>
            <p className="ju-hero-sub">Become part of a global logistics network trusted by professionals across 150+ countries.</p>
          </div>
        </div>
      </section>

      {/* Membership Plans */}
      <section className="ju-plans-section">
        <div className="container">
          <div className="ju-plans-header">
            <h2 className="ju-plans-title">Membership Plans</h2>
            <p className="ju-plans-subtitle">Choose the plan that best fits your business needs and growth objectives</p>
          </div>
          <div className="ju-plans-grid">
            {[
              {
                planName: 'Annual Membership',
                originalPrice: 1200,
                currentPrice: 1200,
                discountPercentage: 0,
                period: '/ year',
                planValue: 'annual',
                badge: null,
                features: [
                  'Access to member directory and partner network',
                  'Business promotion opportunities',
                  'Member support and resources',
                  'Financial protection coverage',
                ],
              },
              {
                planName: '2 Year Membership',
                originalPrice: 2400,
                currentPrice: 2040,
                discountPercentage: 15,
                period: '/ 2 years',
                planValue: '2year',
                badge: 'Most Popular',
                features: [
                  'All Annual benefits included',
                  'Enhanced financial protection',
                  'Priority access to business development opportunities',
                  'Business promotion opportunities',
                ],
              },
              {
                planName: '3 Year Membership',
                originalPrice: 3600,
                currentPrice: 2880,
                discountPercentage: 20,
                period: '/ 3 years',
                planValue: '3year',
                badge: 'Best Value',
                features: [
                  'Maximum financial protection',
                  'Priority event access',
                  'Dedicated member support',
                  'All Annual benefits included',
                ],
              },
            ].map((plan, i) => (
              <div key={i} className={`ju-plan-card ${plan.badge ? 'ju-plan-featured' : ''}`}>
                {plan.badge && <span className="ju-plan-badge">{plan.badge}</span>}
                <div className="ju-plan-top">
                  <h3 className="ju-plan-name">{plan.planName}</h3>
                  <div className="ju-plan-price">
                    {plan.originalPrice > plan.currentPrice && (
                      <span className="ju-plan-original-price">USD {plan.originalPrice.toLocaleString()}</span>
                    )}
                    <span className="ju-plan-amount">USD {plan.currentPrice.toLocaleString()}</span>
                    <span className="ju-plan-period">{plan.period}</span>
                  </div>
                  {plan.discountPercentage > 0 && (
                    <span className="ju-plan-discount-badge">{plan.discountPercentage}% OFF</span>
                  )}
                </div>
                <ul className="ju-plan-features">
                  {plan.features.map((f, j) => (
                    <li key={j}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                      {f}
                    </li>
                  ))}
                </ul>
                <button
                  type="button"
                  className="ju-plan-cta"
                  onClick={() => navigate(`/membership-application?plan=${plan.planValue}`)}
                >
                  Choose Plan
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default JoinUs;
